import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

import { Provider } from "react-redux";
import { persistor, store } from "./libs/redux/store/store";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";

/**
 * El BrowserRouter se debe colocar como contenedor del componente
 * App para poder detectar los cambios de location mediante el uso de useLocation
 */

//"ResizeObserver loop completed with undelivered notifications" es un aviso
//benigno del navegador (las gráficas de los tableros se redimensionan al
//cambiar de pestaña); la capa de errores de desarrollo lo mostraba como
//error y tapaba la pantalla (Diego 2026-09-14). Se deja pasar sin ruido.
const ocultarCapaResizeObserver = () => {
  ["webpack-dev-server-client-overlay", "webpack-dev-server-client-overlay-div"].forEach((id) => {
    const capa = document.getElementById(id);
    if (capa) {
      capa.style.display = "none";
    }
  });
};
window.addEventListener("error", (evento) => {
  if (String(evento?.message ?? "").includes("ResizeObserver loop")) {
    evento.stopImmediatePropagation();
    evento.preventDefault();
    //La capa de desarrollo se pinta despues del evento: se oculta en el siguiente ciclo
    setTimeout(ocultarCapaResizeObserver, 0);
    setTimeout(ocultarCapaResizeObserver, 300);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  //</React.StrictMode>,
);
